import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import styled from 'styled-components';

import { getResultsData } from './utils/results';

import { Category, MobileCategory } from './components/Category';
import Tabs from './components/Tabs';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TabsBar = styled.div`
  display: flex;
  border-bottom: 1px solid grey;
`;

class Results extends React.Component {
  static propTypes = {
    data: PropTypes.array
  };

  state = {
    data: this.props.data,
    isMobile: false,
    model: '',
    selected: 0
  };

  selectCatagory = (e, i, isMobile) => {
    if (isMobile && i === this.state.selected) {
      // collapse all categories
      this.setState({ selected: null });
    } else {
      this.setState({ selected: i });
    }
  };

  componentDidMount() {
    if (
      process.env.NODE_ENV !== 'production' &&
      !this.props.data &&
      typeof window !== 'undefined'
    ) {
      getResultsData().then(data => this.setState({ data }));
    }
    window.sessionStorage.setItem(
      'breadCrumbs',
      JSON.stringify({
        back: false,
        crumbs: [window.location.href]
      })
    );
    if (typeof window !== 'undefined') {
      // figure out model in either desktop or mobile view for Whirlpool
      const parsedParams = queryString.parse(window.location.search);
      const model = parsedParams.model
        ? parsedParams.model
        : window.location.href.split('/').pop();
      const width = window.innerWidth;
      this.setState({ isMobile: width < 900, model });
    }
  }

  render() {
    return this.state.data ? (
      <Wrapper>
        {!this.state.isMobile && (
          <div>
            <TabsBar>
              {this.state.data.map((category, i) => {
                return (
                  <Tabs
                    key={i}
                    index={i}
                    name={category.name}
                    onDisplay={this.state.selected === i}
                    selectCatagory={this.selectCatagory}
                  />
                );
              })}
            </TabsBar>
            <Category
              model={this.state.model}
              topics={this.state.data[this.state.selected].topics}
            />
          </div>
        )}
        {this.state.isMobile &&
          this.state.data.map((category, i) => {
            return (
              <MobileCategory
                index={i}
                isMobile={this.state.isMobile}
                key={i}
                topics={
                  this.state.selected !== null
                    ? this.state.data[this.state.selected].topics
                    : null
                }
                model={this.state.model}
                name={category.name}
                onDisplay={this.state.selected === i}
                selectCatagory={this.selectCatagory}
              />
            );
          })}
      </Wrapper>
    ) : null;
  }
}

export default Results;



// WEBPACK FOOTER //
// ./src/Results.js